export const FACEBOOK_DOMAIN_VERIFICATION = '5g9c22jk7pzaw7dud9x377jujurqul';
